import Flights from "../components/main/body/screens/IAM/Flights/Flights";
import { AdminHomeStore } from "./AdminHomeStore";
import { AdminStore } from "./AdminStore";
import { ChatStore } from "./ChatStore";
import { ConferenceStore } from "./ConferenceStore";
import { EditProfileStore } from "./EditProfileStore";
import { EmsStore } from "./EmsStore";
import { Errorhandling } from "./ErrorHandlingStore";
import { FlightsStore } from "./FlightsStore";
import { HeaderPathStore } from "./HeaderPathStore";
import { HomeScreenStore } from "./HomeScreenStore";
import { LoadingStore } from "./LoadingStore";
import { LoginPromptStore } from "./LoginPromptStore";
import { LongPressStore } from "./LongPressStore";
import { MedicalEmergencyCardStore } from "./MedicalEmergencyCardStore";
import { NotificationToast } from "./NotificationToastStore";
import { OrganizationStore } from "./OrganizationStore";
import { PassengerStore } from "./PassengerStore";
import { RightSidebarStore } from "./RightSidenarStore";
import { RoleStore } from "./RoleStore";
import { SidebarStore } from "./SidebarStore";
import { SuccessMsg } from "./SuccessmsgStore";
import { Errormsg } from "./ErrormsgStore";
import { UserActivityStore } from "./UserActivityStore";
import { userStore } from "./UserStore";
import { MedicalKitStore } from "./MedicalKitStore";
import { PassengerDetailStore } from "./PassengerDetailStore";
import { AssistantStore } from "./AssistantStore";
import { CallingStore } from "./CallingStore";


export interface IRootStore {
    organizationStore:OrganizationStore;
    passengerStore:PassengerStore;
    roleStore:RoleStore;
    emsStore: EmsStore,
    adminStore: AdminStore,
    loadingStore: LoadingStore,
    sidebarStore: SidebarStore,
    errorHandlingStore: Errorhandling,
    notificationToastStore: NotificationToast;
    chatStore: ChatStore;
    loginPromptStore: LoginPromptStore;
    longPressStore: LongPressStore;
    editProfileStore: EditProfileStore;
    rightSidebarStore: RightSidebarStore;
    headerPathStore: HeaderPathStore;
    conferenceStore: ConferenceStore;
    userStore: userStore;
    medicalCardStore: MedicalEmergencyCardStore;
    successStore: SuccessMsg;
    errorStore: Errormsg;
    homeScreenStore: HomeScreenStore;
    flightsStore: FlightsStore;
    userActivityStore: UserActivityStore;
    adminHomeStore: AdminHomeStore;
    medicalKitStore:MedicalKitStore;
    passengerDetailStore: PassengerDetailStore;
    assistantStore: AssistantStore;
    callingStore: CallingStore;
}

export class RootStore implements IRootStore {
    organizationStore:OrganizationStore;
    passengerStore:PassengerStore;
    roleStore:RoleStore;
    emsStore: EmsStore;
    adminStore: AdminStore;
    loadingStore: LoadingStore;
    sidebarStore: SidebarStore;
    errorHandlingStore: Errorhandling;
    notificationToastStore: NotificationToast;
    chatStore: ChatStore;
    loginPromptStore: LoginPromptStore;
    longPressStore: LongPressStore;
    editProfileStore: EditProfileStore;
    rightSidebarStore: RightSidebarStore;
    headerPathStore: HeaderPathStore;
    conferenceStore: ConferenceStore;
    userStore: userStore;
    medicalCardStore: MedicalEmergencyCardStore;
    successStore: SuccessMsg;
    errorStore: Errormsg;
    homeScreenStore: HomeScreenStore;
   flightsStore: FlightsStore;
    userActivityStore: UserActivityStore;
    adminHomeStore: AdminHomeStore;
    medicalKitStore:MedicalKitStore;
    passengerDetailStore: PassengerDetailStore;
    assistantStore: AssistantStore;
    callingStore: CallingStore;

    constructor() {
        this.organizationStore =new OrganizationStore(this);
        this.passengerStore= new PassengerStore(this);
        this.roleStore = new RoleStore(this);
        this.emsStore = new EmsStore(this);
        this.adminStore = new AdminStore(this);
        this.loadingStore = new LoadingStore(this);
        this.sidebarStore = new SidebarStore(this);
        this.errorHandlingStore = new Errorhandling(this);
        this.notificationToastStore = new NotificationToast(this);
        this.chatStore = new ChatStore(this);
        this.loginPromptStore = new LoginPromptStore(this);
        this.longPressStore = new LongPressStore(this);
        this.editProfileStore = new EditProfileStore(this);
        this.rightSidebarStore = new RightSidebarStore(this);
        this.headerPathStore = new HeaderPathStore(this);
        this.conferenceStore = new ConferenceStore(this);
        this.userStore = new userStore(this);
        this.medicalCardStore = new MedicalEmergencyCardStore(this);
        this.successStore = new SuccessMsg(this);
        this.errorStore = new Errormsg(this);
        this.homeScreenStore = new HomeScreenStore(this);
        this.flightsStore = new FlightsStore(this);
        this.userActivityStore = new UserActivityStore(this);
        this.adminHomeStore = new AdminHomeStore(this);
        this.medicalKitStore= new MedicalKitStore(this);
        this.passengerDetailStore = new PassengerDetailStore(this);
        this.assistantStore = new AssistantStore(this);
        this.callingStore = new CallingStore(this);
    }
    
}